import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f0a7ead2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0a7ead2')) {
      api.createRecord('f0a7ead2', component.options)
    } else {
      api.reload('f0a7ead2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f0a7ead2&", function () {
      api.rerender('f0a7ead2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminSystem/index.vue"
export default component.exports